export type SupportedLang =
  | "en" | "es" | "pt" | "it" | "fr" | "zh" | "ur" | "hi" | "de" | "th";

export const languageNames: Record<SupportedLang, string> = {
  en: "English",
  es: "Spanish",
  pt: "Portuguese",
  it: "Italian",
  fr: "French",
  zh: "Chinese",
  ur: "Urdu",
  hi: "Hindi",
  de: "German",
  th: "Thai",
};

export const translations: Record<SupportedLang, Record<string, string>> = {
  en: {
    title: "K9 Coach AI",
    subtitle: "Your personal pet expert",
    demoMode: "Demo Mode",
    messages: "messages",
    voiceMessages: "voice messages",
    unlimited: "Unlimited messages",
    dismissError: "Dismiss error",
    tip: "Tip",

    welcome: "Welcome to K9 Coach AI!",
    askAnything: "Ask me anything about pet training, behavior, or care.",
    uploadImage: "Upload Image",
    copyMessage: "Copy message",
    voiceMessage: "Voice message",
    voiceResponse: "Voice response",

    textPlaceholder: "Type your message...",
    upload: "Upload",
    mic: "Mic",
    send: "Send",
    cancel: "Cancel",

    // 🔽 New
    selectLanguage: "Select Language",
  },

  es: {
    title: "K9 Coach AI",
    subtitle: "Tu experto personal en mascotas",
    demoMode: "Modo Demostración",
    messages: "mensajes",
    voiceMessages: "mensajes de voz",
    unlimited: "Mensajes ilimitados",
    dismissError: "Descartar error",
    tip: "Consejo",

    welcome: "¡Bienvenido a K9 Coach AI!",
    askAnything: "Pregúntame lo que quieras sobre entrenamiento, comportamiento o cuidado de mascotas.",
    uploadImage: "Subir imagen",
    copyMessage: "Copiar mensaje",
    voiceMessage: "Mensaje de voz",
    voiceResponse: "Respuesta de voz",

    textPlaceholder: "Escribe tu mensaje...",
    upload: "Subir",
    mic: "Micrófono",
    send: "Enviar",
    cancel: "Cancelar",

    // 🔽 New
    selectLanguage: "Seleccionar idioma",
  },

  pt: {
    title: "K9 Coach AI",
    subtitle: "Seu especialista pessoal em pets",
    demoMode: "Modo Demo",
    messages: "mensagens",
    voiceMessages: "mensagens de voz",
    unlimited: "Mensagens ilimitadas",
    dismissError: "Dispensar erro",
    tip: "Dica",

    welcome: "Bem-vindo ao K9 Coach AI!",
    askAnything: "Pergunte-me qualquer coisa sobre treinamento, comportamento ou cuidados com pets.",
    uploadImage: "Enviar imagem",
    copyMessage: "Copiar mensagem",
    voiceMessage: "Mensagem de voz",
    voiceResponse: "Resposta de voz",

    textPlaceholder: "Digite sua mensagem...",
    upload: "Enviar",
    mic: "Microfone",
    send: "Enviar",
    cancel: "Cancelar",

    // 🔽 New
    selectLanguage: "Selecionar idioma",
  },

  it: {
    title: "K9 Coach AI",
    subtitle: "Il tuo esperto personale di animali domestici",
    demoMode: "Modalità Demo",
    messages: "messaggi",
    voiceMessages: "messaggi vocali",
    unlimited: "Messaggi illimitati",
    dismissError: "Ignora errore",
    tip: "Suggerimento",

    welcome: "Benvenuto su K9 Coach AI!",
    askAnything: "Chiedimi qualsiasi cosa sull'addestramento, il comportamento o la cura degli animali.",
    uploadImage: "Carica immagine",
    copyMessage: "Copia messaggio",
    voiceMessage: "Messaggio vocale",
    voiceResponse: "Risposta vocale",

    textPlaceholder: "Scrivi il tuo messaggio...",
    upload: "Carica",
    mic: "Microfono",
    send: "Invia",
    cancel: "Annulla",

    // 🔽 New
    selectLanguage: "Seleziona lingua",
  },

  fr: {
    title: "K9 Coach AI",
    subtitle: "Votre expert personnel en animaux de compagnie",
    demoMode: "Mode Démo",
    messages: "messages",
    voiceMessages: "messages vocaux",
    unlimited: "Messages illimités",
    dismissError: "Ignorer l'erreur",
    tip: "Astuce",

    welcome: "Bienvenue sur K9 Coach AI !",
    askAnything: "Demandez-moi tout sur l'éducation, le comportement ou les soins des animaux de compagnie.",
    uploadImage: "Téléverser une image",
    copyMessage: "Copier le message",
    voiceMessage: "Message vocal",
    voiceResponse: "Réponse vocale",

    textPlaceholder: "Tapez votre message...",
    upload: "Téléverser",
    mic: "Micro",
    send: "Envoyer",
    cancel: "Annuler",

    // 🔽 New
    selectLanguage: "Choisir la langue",
  },

  zh: {
    title: "K9 教练 AI",
    subtitle: "您的个人宠物专家",
    demoMode: "演示模式",
    messages: "消息",
    voiceMessages: "语音消息",
    unlimited: "无限消息",
    dismissError: "关闭错误",
    tip: "提示",

    welcome: "欢迎使用 K9 教练 AI！",
    askAnything: "请向我询问任何关于宠物训练、行为或护理的问题。",
    uploadImage: "上传图片",
    copyMessage: "复制消息",
    voiceMessage: "语音消息",
    voiceResponse: "语音回复",

    textPlaceholder: "输入您的消息...",
    upload: "上传",
    mic: "麦克风",
    send: "发送",
    cancel: "取消",

    // 🔽 New
    selectLanguage: "选择语言",
  },

  ur: {
    title: "کے9 کوچ اے آئی",
    subtitle: "آپ کا ذاتی پالتو جانور ماہر",
    demoMode: "ڈیمو موڈ",
    messages: "پیغامات",
    voiceMessages: "آواز کے پیغامات",
    unlimited: "لامحدود پیغامات",
    dismissError: "غلطی بند کریں",
    tip: "مشورہ",

    welcome: "کے9 کوچ اے آئی میں خوش آمدید!",
    askAnything: "پالتو جانوروں کی تربیت، رویے یا دیکھ بھال کے بارے میں کچھ بھی پوچھیں۔",
    uploadImage: "تصویر اپ لوڈ کریں",
    copyMessage: "پیغام کاپی کریں",
    voiceMessage: "آواز کا پیغام",
    voiceResponse: "آواز کا جواب",

    textPlaceholder: "اپنا پیغام لکھیں...",
    upload: "اپ لوڈ",
    mic: "مائیک",
    send: "بھیجیں",
    cancel: "منسوخ کریں",

    // 🔽 New
    selectLanguage: "زبان منتخب کریں",
  },

  hi: {
    title: "के9 कोच एआई",
    subtitle: "आपका व्यक्तिगत पालतू विशेषज्ञ",
    demoMode: "डेमो मोड",
    messages: "संदेश",
    voiceMessages: "वॉइस संदेश",
    unlimited: "असीमित संदेश",
    dismissError: "त्रुटि बंद करें",
    tip: "सुझाव",

    welcome: "K9 Coach AI में आपका स्वागत है!",
    askAnything: "पालतू जानवरों के प्रशिक्षण, व्यवहार या देखभाल के बारे में कुछ भी पूछें।",
    uploadImage: "चित्र अपलोड करें",
    copyMessage: "संदेश कॉपी करें",
    voiceMessage: "वॉइस संदेश",
    voiceResponse: "वॉइस प्रतिक्रिया",

    textPlaceholder: "अपना संदेश लिखें...",
    upload: "अपलोड",
    mic: "माइक",
    send: "भेजें",
    cancel: "रद्द करें",

    // 🔽 New
    selectLanguage: "भाषा चुनें",
  },

  de: {
    title: "K9 Coach KI",
    subtitle: "Ihr persönlicher Haustierexperte",
    demoMode: "Demo-Modus",
    messages: "Nachrichten",
    voiceMessages: "Sprachnachrichten",
    unlimited: "Unbegrenzte Nachrichten",
    dismissError: "Fehler schließen",
    tip: "Tipp",

    welcome: "Willkommen bei K9 Coach AI!",
    askAnything: "Frag mich alles über Tiertraining, Verhalten oder Pflege.",
    uploadImage: "Bild hochladen",
    copyMessage: "Nachricht kopieren",
    voiceMessage: "Sprachnachricht",
    voiceResponse: "Sprachantwort",

    textPlaceholder: "Schreiben Sie Ihre Nachricht...",
    upload: "Hochladen",
    mic: "Mikrofon",
    send: "Senden",
    cancel: "Abbrechen",

    // 🔽 New
    selectLanguage: "Sprache auswählen",
  },
   th: {
    title: "K9 Coach AI",
    subtitle: "ผู้เชี่ยวชาญสัตว์เลี้ยงส่วนตัวของคุณ",
    demoMode: "โหมดสาธิต",
    messages: "ข้อความ",
    voiceMessages: "ข้อความเสียง",
    unlimited: "ไม่จำกัดข้อความ",
    dismissError: "ปิดข้อผิดพลาด",
    tip: "เคล็ดลับ",

    welcome: "ยินดีต้อนรับสู่ K9 Coach AI!",
    askAnything: "ถามฉันได้ทุกอย่างเกี่ยวกับการฝึก การดูแล หรือพฤติกรรมสัตว์เลี้ยงของคุณ",
    uploadImage: "อัปโหลดรูปภาพ",
    copyMessage: "คัดลอกข้อความ",
    voiceMessage: "ข้อความเสียง",
    voiceResponse: "การตอบกลับด้วยเสียง",

    textPlaceholder: "พิมพ์ข้อความของคุณ...",
    upload: "อัปโหลด",
    mic: "ไมโครโฟน",
    send: "ส่ง",
    cancel: "ยกเลิก",

    // 🔽 New
    selectLanguage: "เลือกภาษา",
  },
};


export default translations;
